import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-indicator-bar',
  templateUrl: './indicator-bar.component.html',
  styleUrls: ['./indicator-bar.component.scss']
})
export class IndicatorBarComponent implements OnInit {
  @Input() used: string = '';
  @Input() total: string = '';
  @Input() label: string = '';
  @Input() unit: string = '';
  @Input() lowThreshold: number = 0.15; // 15% free triggers red

  percentUsed: number = 0;
  barColor: string = 'var(--indicator-bar-ok, #1890ff)';
  displayText: string = '';

  ngOnInit(): void {
    this.calculateBar();
  }

  ngOnChanges(): void {
    this.calculateBar();
  }

  private parseValue(val: string): number {
    if (!val) return 0;
    // Remove non-numeric except dot and unit
    const num = parseFloat(val.replace(/[^0-9.]/g, ''));
    return isNaN(num) ? 0 : num;
  }

  private calculateBar(): void {
    const usedVal = this.parseValue(this.used);
    const totalVal = this.parseValue(this.total);
    this.percentUsed = totalVal > 0 ? usedVal / (totalVal + usedVal): 0;
    // Color logic: red if less than threshold free, else blue
    if (totalVal > 0 && (1 - this.percentUsed) < this.lowThreshold) {
      this.barColor = 'var(--indicator-bar-low, #ff4d4f)';
    } else {
      this.barColor = 'var(--indicator-bar-ok, #1890ff)';
    }
    this.displayText = `${this.parseValue(this.used).toFixed(2)} GB / ${(totalVal + usedVal).toFixed(2)} GB used`;
  }
} 
